(function (root) {
  'use strict';
  // Tea To-Go cart rules (docs/CART_LOGIC.md) by exact store domain. Absent = feature off.
  const environments = {
    'drstolberg.myshopify.com': {
      // The live 5-pack is a Shopify bundle, and Shopify sells bundles without
      // subscription plans only, so packs are offered for this order only.
      packs: { teaVariantId: 50889447407849, packVariantId: 51287164322025, packHandle: '5-single-serve-packets', recurring: false }
    },
    'doctor-stolberg-test-store.myshopify.com': {
      packs: { teaVariantId: 67673663864943, packVariantId: 67673678151791, packHandle: '5-single-serve-packets-test' }
    }
  };
  function freeze(value) {
    Object.values(value).forEach(child => { if (child && typeof child === 'object') freeze(child); });
    return Object.freeze(value);
  }
  const api = freeze(environments);
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.TeaAddonEnvironments = api;
})(typeof window === 'undefined' ? globalThis : window);
